var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"video-modal-ref",attrs:{"id":"video-modal","hide-footer":"","title":_vm.title}},[_c('video-stream',{attrs:{"options":_vm.videoOptions}}),_c('b-button',{staticClass:"mt-3",attrs:{"block":""},on:{"click":function($event){return _vm.hide()}}},[_vm._v(" Close ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }